import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/CustomersApi/Customers";
import { validateForm } from "utils/validation";
import { CustomersRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditCustomerForm from "./Componates/EditCustomerForm";
import fields from "../json/CustomersFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditCustomer = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  // Combine all possible fields for default state (memoized to prevent reruns)
  const allFields = useMemo(
    () => [...fields.common, ...fields.native, ...fields.foreigner, ...fields.country_dial_code],
    []
  );

  const initialValues = useMemo(() => {
    return allFields.reduce((acc, field) => {
      acc[field.name] = "";
      return acc;
    }, {});
  }, [allFields]);

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } =
    useFormChange(initialValues, CustomersRules);

  // Fetch data once — must not loop
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    allFields,
    GetById,
    setValues
  );

  const cleanNationalityValues = (vals) => {
    const cleaned = { ...vals };

    // Remove preview-only keys
    ["img_frontPreview", "img_backPreview", "img_guestPreview", "profile_imagePreview"]
      .forEach((k) => delete cleaned[k]);

    // Remove image fields that are still strings (URLs from API — not new File uploads)
    ["img_front", "img_back", "img_guest", "profile_image"].forEach((k) => {
      if (typeof cleaned[k] === "string") delete cleaned[k];
    });

    if (cleaned.is_nationality === "national") {
      fields.foreigner.forEach((f) => delete cleaned[f.name]);
    }

    if (cleaned.is_nationality === "foreigner") {
      fields.native.forEach((f) => delete cleaned[f.name]);
    }

    return cleaned;
  };


  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const cleanedValues = cleanNationalityValues(formValues);

      const formData = new FormData();
      Object.entries(cleanedValues).forEach(([key, val]) => {
        if (val instanceof File) {
          formData.append(key, val);
        } else {
          formData.append(key, val === undefined || val === null ? "" : String(val));
        }
      });

      return await Update({ id, data: formData });
    },

    (vals) => {
      const cleanedValues = cleanNationalityValues(vals);
      const err = validateForm(cleanedValues, CustomersRules);
      setErrors(err);
      return err;
    },

    () => navigate(-1),
    "Customer Updated successfully!"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditCustomerForm
        fields={fields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        handleFileChange={handleFileChange}
        title="Update Customer"
        img_frontPreview={values.img_frontPreview || values.img_front}
        img_backPreview={values.img_backPreview || values.img_back}
        img_guestPreview={values.img_guestPreview || values.img_guest}
        profile_imagePreview={values.profile_imagePreview || values.profile_image}
      />
    </>
  );
};

export default EditCustomer;
